﻿import { useCallback, useState } from 'react'
import { Button, Page } from '@shopify/polaris'
import { StoreReportsPanel } from '@/components/reports/StoreReportsPanel'
import { useGenerateReport } from '@/hooks/useReports'

export function ReportsPage() {
  const [activeId, setActiveId] = useState<number | null>(null)
  const { mutate: generate, isPending: isGenerating, error: generateError } = useGenerateReport()

  const handleGenerate = useCallback(() => {
    generate(undefined, { onSuccess: (res) => setActiveId(res.data.id) })
  }, [generate])

  return (
    <Page
      fullWidth
      title="Reports"
      subtitle="Snapshot reports combining audit data with an AI executive summary"
      primaryAction={
        activeId === null
          ? <Button variant="primary" loading={isGenerating} onClick={handleGenerate}>Generate Report</Button>
          : undefined
      }
    >
      <StoreReportsPanel
        activeId={activeId}
        onSelectReport={setActiveId}
        hasGenerateError={!!generateError}
      />
    </Page>
  )
}
